import Lottie from "lottie-react";
import contact from "../images/contact.json";
import Aos from "aos";
import { useEffect } from "react";
import "aos/dist/aos.css";
const Contact = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <div
      data-aos="fade-right"
      className="min-h-[500px] overflow-hidden py-8 px-10 mt-10 rounded-[30px]"
    >
      <h1 className="sm:text-5xl text-3xl font-bold text-center w-full mb-2">
        Let's start a project together
      </h1>
      <div className="flex justify-around items-center lg:flex-row md:flex-col-reverse flex-col-reverse">
        <div className="flex flex-col">
          <input
            className="border focus:border-[#FE4904] border-black-500 outline-none h-[50px] px-4 py-6 text-lg rounded-lg sm:w-[400px] w-[300px] my-3"
            type="text"
            placeholder="ex.John Doe"
          />
          <input
            className="border focus:border-[#FE4904] border-black-500 outline-none h-[50px] px-4 py-6 text-lg rounded-lg sm:w-[400px] w-[300px] my-3"
            type="text"
            placeholder="ex.example@gmail.com"
          />
          <input
            className="border focus:border-[#FE4904] border-black-500 outline-none h-[50px] px-4 py-6 text-lg rounded-lg sm:w-[400px] w-[300px] my-3"
            type="text"
            placeholder="message"
          />
          <button className="bg-gradient-to-r from-[#FE4904] to-[#F7164C] hover:from-[#F7164C] hover:to-[#FE4904] sm:px-10 sm:py-5 px-2 py-3 rounded-xl mt-2 text-white transition ease-in-out text-lg">
            Read More
          </button>
        </div>
        <div>
          <Lottie className="sm:w-[550px] w-[350px]" animationData={contact} />
        </div>
      </div>
    </div>
  );
};
export default Contact;
